module.exports = __webpack_public_path__ + "static/media/5.c74d98f3.svg";